import { env } from '$env/dynamic/public'
import { ready, subscribe } from '@payloadcms/live-preview'
import { getContext, setContext } from 'svelte'

const LIVEPREVIEW = Symbol('LIVEPREVIEW')

export function createLivePreviewContext(): LivePreviewContext {
      return setContext(LIVEPREVIEW, new LivePreviewContext())
}

export function getLivePreviewContext(): LivePreviewContext {
      return getContext(LIVEPREVIEW)
}

class LivePreviewContext {
      livePreview: string | false = $state(false)
      initialData: any
      onChange: ((data: any) => void) | null = null

      constructor() {
            return this
      }

      setLivePreviewType({ livePreview }: { livePreview: string | false }) {
            this.livePreview = livePreview
            return this
      }

      registerLivePreview({ livePreview, initialData, onChange }: { livePreview: string | false; initialData: any; onChange: (data:any) => void }) {
        if (livePreview != this.livePreview ) return this
            this.initialData = initialData
            this.onChange = onChange
            this.setupLivePreview()
            return this
      }

      setupLivePreview() {
            if (!this.onChange) return

            console.log("setting up livepreview", env.PUBLIC_PAYLOAD_URL)

            let hasSentReadyMessage = false
            const serverURL = env.PUBLIC_PAYLOAD_URL
            let depth = 2

            const subscription = subscribe({
                  callback: this.onChange,
                  depth,
                  initialData: this.initialData,
                  serverURL,
            })

            if (!hasSentReadyMessage) {
                  hasSentReadyMessage = true
                  ready({ serverURL })
            }

            return subscription
      }

}
